import InputFactory from '../factories/input-factory.js';
import Form from '../form.js';
import PromiseReducer from '../helpers/promise-reducer.js';

export default class FormField {
    constructor(parent, el) {
        this.parent = parent;
        this.form = parent instanceof Form ? parent : parent.form;
        this.el = el;
        this.label = el.querySelector('label')?.textContent;
        this.buildInputs();
        this.populateInputs();
    }

    buildInputs() {
        this.inputs = [...this.el.querySelectorAll('input, select, textarea')].map((i) => InputFactory.build(this, i));
    }

    populateInputs() {
        this.inputs.forEach((i) => i.populate());
    }

    id() {
        return this.el.dataset.id;
    }

    input(id) {
        return this.inputs.find((i) => id === i.id());
    }

    update() {
        this.valid().then((valid) => this.parent.update(this, valid));
    }

    valid(silent) {
        return this.disabled()
            ? Promise.resolve(true)
            : PromiseReducer.all(this.inputs.map((i) => i.valid())).then((valid) => {
                  if (!silent) {
                      this.toggle(valid);
                  }
                  return valid;
              });
    }

    async focusOnFirstInvalid() {
        for (const input of this.inputs) {
            const isValid = await input.valid(true);

            if (isValid) {
                continue;
            }

            input.focus();
            break;
        }
    }

    reset() {
        this.inputs.forEach((i) => i.reset());
    }

    toggle(valid) {
        const errorMessage = this.el.querySelector('.form_field_error_message');
        const inputElement = this.el.querySelector('input, select, textarea');

        if (valid && errorMessage && inputElement) {
            this.el.classList.remove('form_field_error');
            inputElement.setAttribute('aria-invalid', 'false');
        } else {
            this.el.classList.add('form_field_error');

            if (inputElement && errorMessage) {
                inputElement.setAttribute('aria-invalid', 'true');
            }
        }
    }

    populated() {
        return this.disabled() ? true : PromiseReducer.all(this.inputs.map((i) => i.populated()));
    }

    enable() {
        delete this.el.dataset.disabled;
    }

    disable() {
        this.el.dataset.disabled = true;
        this.reset();
    }

    disabled() {
        return this.el.dataset.disabled !== undefined;
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    static is(el) {
        return el.classList.contains('form_field');
    }
}
